// Presentation layouts of container children, as the API sends them. The components they select are
// in the presentation map of `components/containerItems/list/ListLayout`.
export const ITEM_CARD = 'ItemCard';
export const EPISODE_CARD = 'EpisodeCard';

// These render only inside the NowPlaying dialog on mobile and have nothing to show anywhere else.
export const MOBILE_ONLY_CHILD_LAYOUTS = [ITEM_CARD, EPISODE_CARD];
